import { graphql } from '../graphql';

export const projectFoldersQuery = graphql(`
  query ProjectFolders {
    projectFolders {
      id
      name
    }
  }
`);

export const createProjectFolderMutation = graphql(`
  mutation CreateProjectFolder($name: String!) {
    createProjectFolder(name: $name) {
      id
      name
    }
  }
`);

export const renameProjectFolderMutation = graphql(`
  mutation RenameProjectFolder($id: ID!, $name: String!) {
    renameProjectFolder(id: $id, name: $name) {
      id
      name
    }
  }
`);

export const deleteProjectFolderMutation = graphql(`
  mutation DeleteProjectFolder($id: ID!) {
    deleteProjectFolder(id: $id)
  }
`);

export const moveProjectToFolderMutation = graphql(`
  mutation MoveProjectToFolder($projectId: ID!, $folderId: ID) {
    moveProjectToFolder(projectId: $projectId, folderId: $folderId) {
      id
      folderId
    }
  }
`);
